import { DeviceStatus, PairingState } from '../../installation/api/installations'
import { getDeviceIsPaired } from './get-device-is-paired'

export const getDeviceStatus = (pairingState: PairingState | null, deviceStatus: DeviceStatus | null): DeviceStatus => {
  const isPaired = getDeviceIsPaired(pairingState)

  if (isPaired) {
    return deviceStatus ?? 'unknown'
  } else {
    return 'unknown'
  }
}
